import axios from 'axios';
import { authError } from './features/user/userSlice';

const attachToken = (config) => {
    const token = window.localStorage.getItem('googleAuthToken');
    if (token) {
        config.headers.Authorization = `Bearer ${token}`;
    }
    return config;
};

export const attachInterceptors = (store) => {
    axios.interceptors.request.use(attachToken);

    axios.interceptors.response.use(
        (response) => response,
        (error) => {
            if (error.response && error.response.status === 401) {
                store.dispatch(authError());
            }
            return Promise.reject(error);
        }
    );
};

export { axios };
